export default __webpack_public_path__ + "static/media/ved.075e992e.jpg";